import _get from "lodash/get";
import { apiErrorHandler, axiosInstance, smpAxiosInstance } from "./config.js";
export { axiosInstance, smpAxiosInstance };

export function get(endpoint) {
  return new Promise((res, rej) => {
    axiosInstance
      .get(endpoint)
      .then((response) => {
        console.log("api axios get");
        console.log(response);
        res(response.data);
      })
      .catch((err) => {
        console.log("api axios get error");
        console.log(JSON.stringify(err, null, 2));
        rej(err ? err : err.response.data);
      });
  });
}
export function smpGet(endpoint) {
  return new Promise((res, rej) => {
    smpAxiosInstance
      .get(endpoint)
      .then((response) => {
        console.log("axios get");
        console.log(response);
        res(response.data);
      })
      .catch((err) => {
        rej(_get(err, "response.data", err.message));
      });
  });
}

export async function getPaginatedData(
  axios,
  endpoint,
  paginationParams,
  parallelRequests,
  controller
) {
  const { page: initialPage, size } = paginationParams;
  let page = initialPage;
  let data = [];

  let responses = [];
  do {
    // Start the specified number of requests in parallel
    responses = await Promise.all(
      Array.from(Array(parallelRequests), (_, i) => {
        return axios
          .get(endpoint, {
            params: { page: page + i, size },
            signal: controller?.signal,
          })
          .catch(apiErrorHandler);
      })
    );

    // Concatenate the data from the responses and increment the page numbers
    responses.forEach((response) => {
      data = data.concat(response.data);
    });

    page += parallelRequests;
  } while (
    responses.every((response) => response.data?.length) &&
    !controller?.signal?.aborted
  );

  return data;
}

export async function smpPost(endpoint, data) {
  return new Promise((res, rej) => {
    smpAxiosInstance
      .post(endpoint, data)
      .then((response) => {
        console.log("smpAxiosInstance Post");
        console.log(response);
        res(response.data);
      })
      .catch((err) => {
        console.log("smpAxiosInstance Post error");
        console.log(err.response);
        rej(_get(err, "response.data", err.message));
      });
  });
}

export async function post(endpoint, data, config = {}) {
  return new Promise((res, rej) => {
    axiosInstance
      .post(endpoint, data, config)
      .then((response) => {
        console.log("axios sendData post");
        console.log(response);
        if (_get(response, "data.httpCode") === 500) {
          throw new Error(
            _get(response, "data.message", "Something went wrong.")
          );
        }
        res(response.data);
      })
      .catch((err) => {
        console.log("axios sendData error");
        console.log(err);
        console.log(err.message);
        console.log(err.response);
        rej(
          _get(err, "response.data.message") ||
            _get(err, "response.data", err.message)
        );
      });
  });
}
export async function patch(endpoint, data) {
  return new Promise((res, rej) => {
    axiosInstance
      .patch(endpoint, data)
      .then((response) => {
        console.log("axios sendData patch");
        console.log(response);
        res(response.data);
      })
      .catch((err) => {
        console.log("axios sendData error");
        console.log(err.response);
        rej(_get(err, "response.data", err.message));
      });
  });
}
export async function put(endpoint, data) {
  return new Promise((res, rej) => {
    axiosInstance
      .put(endpoint, data)
      .then((response) => {
        console.log("axios put");
        console.log(response);
        res(response.data);
      })
      .catch((err) => {
        console.log("axios put error");
        console.log(err.response);
        rej(_get(err, "response.data", err.message));
      });
  });
}
